import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
  HttpResponse
} from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private auth: AuthService,
    private translateService: TranslateService) { }


  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(catchError((err: HttpErrorResponse) => {
      let error = null;
      if (err.status === 200) {
        return of(new HttpResponse({
          headers: request.headers,
          url: request.url
        }));
      }

      if ([400, 401, 404].includes(err.status)) {
        error = typeof err.error === 'string' ? err.error : err.error?.message ?? err.message;
      } else {
        error = this.translateService.instant('error.request');
      }

      // if(err.status === 401) {
      //  this.auth.logout();
      // }

      return throwError(error);
    })) as Observable<HttpEvent<unknown>>;
  }
}
